import * as React from 'react'

import './styles.scss'

const LoadingLinear = ({ className }) => {
  return (
    <div className={`LinearProgress-root ${className || ''}`} role="progressbar">
      <div className="LinearProgress-bar LinearProgress-bar1"></div>
      <div className="LinearProgress-bar LinearProgress-bar2"></div>
    </div>
  )
}

export default LoadingLinear
